import React from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success'
type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  icon?: React.ReactNode
  children?: React.ReactNode
}

const sizeStyles: Record<ButtonSize, React.CSSProperties> = {
  sm: { padding: '6px 12px', fontSize: '12px', gap: '6px' },
  md: { padding: '8px 16px', fontSize: '13px', gap: '8px' },
  lg: { padding: '10px 20px', fontSize: '14px', gap: '8px' },
}

const variantBaseStyles: Record<ButtonVariant, React.CSSProperties> = {
  primary: {
    backgroundColor: 'var(--brand)',
    color: '#fff',
    border: 'none',
  },
  secondary: {
    backgroundColor: 'transparent',
    color: 'var(--text-secondary)',
    border: '1px solid var(--border-default)',
  },
  ghost: {
    backgroundColor: 'transparent',
    color: 'var(--text-secondary)',
    border: 'none',
  },
  danger: {
    backgroundColor: 'transparent',
    color: 'var(--status-unhealthy)',
    border: '1px solid var(--status-unhealthy)',
  },
  success: {
    backgroundColor: 'var(--status-healthy)',
    color: '#fff',
    border: 'none',
  },
}

export function Button({ variant = 'secondary', size = 'md', icon, children, className, style, disabled, ...props }: ButtonProps) {
  const variantClass = `btn-${variant}`
  return (
    <button
      className={`${variantClass} ${className ?? ''}`}
      disabled={disabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        borderRadius: 'var(--radius-md)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: 'var(--font-sans)',
        opacity: disabled ? 0.5 : 1,
        whiteSpace: 'nowrap',
        ...sizeStyles[size],
        ...variantBaseStyles[variant],
        ...style,
      }}
      {...props}
    >
      {icon}
      {children}
    </button>
  )
}
